export default __webpack_public_path__ + "static/media/7.392ba0ee.png";